import React from 'react';

const RELOAD_KEY = 'chunk_reload_once';

// Incarcare ecran la cerere; daca bucata JS lipseste (deploy nou), reincarca pagina o singura data.
export const lazyPage = (factory) => React.lazy(() =>
  factory()
    .then((m) => { sessionStorage.removeItem(RELOAD_KEY); return m; })
    .catch((err) => {
      if (!sessionStorage.getItem(RELOAD_KEY)) {
        sessionStorage.setItem(RELOAD_KEY, '1');
        window.location.reload();
        return new Promise(() => {});
      }
      throw err;
    })
);

export const PageFallback = () => (
  <div data-testid="page-loading" className="p-6 text-sm text-gray-400">...</div>
);
